export abstract class BaseResponse{
    success: boolean;
    message: string;
}